<template>
  <main class="inner-layout">
    <div class="inner-layout__banner">
      <slot name="banner"/>
    </div>
    <div class="inner-layout__content">
      <slot/>
    </div>
  </main>
</template>

<style lang="scss" scoped>
.inner-layout {
  .inner-layout__banner {
    margin-bottom: 100px;
    @media (max-width: 991px) {
      margin-bottom: 50px;
    }
  }
}
</style>
